import React from 'react';
import { useTranslation } from 'react-i18next';

const Step4WasteInfo = ({ formData = {}, onChange = () => {}, errors = {} }) => {
  const { t } = useTranslation();

  const baseTextAreaClass =
    'w-full p-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-primaryAccent transition-colors duration-200 text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-800';

  const getBorderClass = (hasError) =>
    hasError ? 'border-red-500' : 'border-gray-300 dark:border-gray-600';

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
        {t('partnerJoin.step4.title')}
      </h2>

      {/* Jenis Sampah yang Diterima */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step4.acceptedWaste')} <span className="text-red-500">*</span>
        </label>
        <textarea
          name="acceptedWaste"
          rows={3}
          value={formData.acceptedWaste || ''}
          onChange={onChange}
          className={`${baseTextAreaClass} ${getBorderClass(errors.acceptedWaste)}`}
          placeholder={t('partnerJoin.step4.acceptedWastePlaceholder')}
        />
        {errors.acceptedWaste && (
          <p className="text-sm text-red-500 mt-1">{errors.acceptedWaste}</p>
        )}
      </div>

      {/* Sistem Insentif */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step4.incentiveSystem')}
        </label>
        <textarea
          name="incentiveSystem"
          rows={3}
          value={formData.incentiveSystem || ''}
          onChange={onChange}
          className={`${baseTextAreaClass} ${getBorderClass(false)}`}
          placeholder={t('partnerJoin.step4.incentiveSystemPlaceholder')}
        />
      </div>

      {/* Sistem Transaksi */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step4.transactionSystem')}
        </label>
        <textarea
          name="transactionSystem"
          rows={3}
          value={formData.transactionSystem || ''}
          onChange={onChange}
          className={`${baseTextAreaClass} ${getBorderClass(false)}`}
          placeholder={t('partnerJoin.step4.transactionSystemPlaceholder')}
        />
      </div>
    </div>
  );
};

export default Step4WasteInfo;
